<template>
	<div v-if="data" class="category-research">
		<div class="category-header">
			<ja-building-header
				:asset="`categories/${category.assetName}`"
				:billboard-asset="billboard"
			></ja-building-header>
		</div>
		<div class="research-heading">
			<h1>{{ category.name }}</h1>
			<h2 class="heading-3">{{ data.researchHeader }}</h2>
		</div>
		<div v-if="data.cmsExpenseCategoryLogos.length" class="logo-area-wrapper">
			<div class="logo-area-inner">
				<div
					v-for="logo in data.cmsExpenseCategoryLogos.filter(
						logo => !!logo.imageBase64
					)"
					:key="logo.expenseCategoryLogo_ID"
					class="logo-area"
				>
					<img :src="logo.imageBase64" alt="" />
				</div>
			</div>
		</div>
		<div class="category-info-wrapper">
			<div
				v-for="(research, index) in data.cmsExpenseCategoryResearches"
				:key="index"
				class="category-info"
			>
				<div v-if="research.imageBase64" class="img-wrapper">
					<img :src="research.imageBase64" alt="" />
				</div>
				<h4 v-if="research.title" class="heading-4">{{ research.title }}</h4>
				<div class="body-text-1" role="article">
					{{ research.description }}
				</div>
			</div>
		</div>
		<div class="quote-banner">
			<div class="banner-content">
				<label id="banner-text">
					<div class="heading-5">{{ $t('didYouKnow') }}...</div>
					<div class="heading-1">
						{{ data.researchDidYouKnowText }}
					</div>
				</label>
				<div class="body-text-2">
					<a
						:href="data.researchDidYouKnowSource"
						target="_blank"
						rel="noopener"
					>
						{{ data.researchDidYouKnowSource }}</a
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import BuildingHeader from '@/components/ui/headers/BuildingHeader';
export default {
	components: {
		jaBuildingHeader: BuildingHeader
	},
	props: {
		category: {
			type: Object,
			default: null
		},
		data: {
			type: Object,
			default: null
		}
	},
	computed: {
		billboard() {
			return this.$store.getters.billboardByCategory(
				this.category.expenseCategory_ID
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.category-research {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;

	.category-image {
		width: 768px;
		margin: auto;
	}

	.research-heading {
		max-width: 768px;
		width: 66%;
		margin: auto;
		flex-shrink: 0;
		text-align: center;

		h1 {
			margin-top: 0;
			margin-bottom: 16px;
		}

		h2 {
			margin-bottom: 0;
		}
	}

	.logo-area-wrapper {
		flex-shrink: 0;
		width: 100%;
		max-width: 1000px;
		margin: 32px auto 0 auto;

		.logo-area-inner {
			width: 100%;
			display: flex;
			justify-content: center;
			padding: 0 5%;

			.logo-area {
				width: 25%;
				max-width: 25%;
				display: flex;
				justify-content: center;

				&:not(:last-child) {
					margin-right: 16px;
				}

				img {
					max-width: 100%;
					max-height: 150px;
				}
			}
		}
	}

	.category-info-wrapper {
		flex-shrink: 0;
		width: 42%;
		text-align: center;
		margin: 32px auto;

		.heading-4 {
			margin-top: 0;
			margin-bottom: 8px;
		}

		.category-info {
			&:not(:last-child) {
				margin-bottom: 24px;
			}

			.body-text-1 {
				font-size: 17px;

				@media (min-width: $breakpoint-mid) {
					font-size: 20px;
				}
			}

			.img-wrapper {
				max-height: 250px;
				max-width: 250px;
				border-radius: 100%;
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 24px auto;
				height: 250px;

				img {
					width: auto;
				}
			}
		}
	}

	.quote-banner {
		flex-shrink: 0;
		width: 100%;
		background-color: #02009e;
		padding: 32px;

		.heading-1 {
			margin: 16px 0;
		}

		.heading-1,
		.heading-5 {
			color: $font-light;
		}

		.banner-content {
			width: 66%;
			margin: auto;
			text-align: center;

			.body-text-2 {
				color: #adbdca;

				a {
					color: inherit;
					text-decoration: unset;
					&:hover {
						cursor: pointer;
					}
				}
			}
		}
	}
}
</style>
